module.exports = __webpack_public_path__ + "img/email.6d38b7ec.svg";